import React, { useRef, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { useTranslation } from 'react-i18next';

// 분리된 컴포넌트들
import QAHeader from './QAHeader';
import QAGuidanceMessage from './QAGuidanceMessage';
import QAHistoryItem from './QAHistoryItem';
import RecommendedQuestions from './RecommendedQuestions';
import QAInputForm from './QAInputForm';

// 훅들
import { useQAScrolling, useQAForm } from '../../hooks/useQA';

// 스타일
import { qaSectionStyles } from '../../styles/qaStyles';

const QASection = ({
  qaInput,
  setQaInput,
  qaLoading,
  handleQaSend,
  qaHistory,
  recommendedQuestions,
  handleRecommendedQuestionClick,
  qaScrollRef,
  summary,
  chapters
}) => {
  // 커스텀 훅들
  const qaScrolling = useQAScrolling(qaHistory);
  const qaForm = useQAForm(qaInput, qaLoading, handleQaSend);

  // 답변 박스별 ref 배열 준비
  qaScrolling.initializeAnswerRefs();

  // 핵심요약과 챕터별 정리 준비 여부
  const isSummaryReady = !!summary;
  const isChaptersReady = Array.isArray(chapters) ? chapters.length > 0 : (chapters?.chapters || []).length > 0;

  return (
    <Paper elevation={0} sx={qaSectionStyles.container}>
      <QAHeader />

      {/* 단일 스크롤 영역으로 통합하여 바운스 효과 개선 */}
      <Box 
        className="scrollable-content qa-scroll-container"
        sx={qaSectionStyles.scrollContainer}
      >
        {/* 안내 메시지 */}
        <QAGuidanceMessage />

        {/* QA 히스토리 */}
        {qaHistory.length > 0 && qaHistory.map((qa, idx) => (
          <QAHistoryItem
            key={idx}
            qa={qa}
            index={idx}
            answerRef={qaScrolling.answerRefs[idx]}
          />
        ))}

        {/* 추천질문 */}
        <RecommendedQuestions
          recommendedQuestions={recommendedQuestions}
          handleRecommendedQuestionClick={handleRecommendedQuestionClick}
          isSummaryReady={isSummaryReady}
          isChaptersReady={isChaptersReady}
        />

        {/* 스크롤 여유 공간 */}
        <Box sx={{ minHeight: 20 }} />
      </Box>

      {/* 입력 폼 (데스크톱/모바일) */}
      <QAInputForm
        qaInput={qaInput}
        setQaInput={setQaInput}
        qaLoading={qaLoading}
        handleSubmit={qaForm.handleSubmit}
      />
    </Paper>
  );
};

export default QASection; 